import { render } from "./VariantsMeta.vue?vue&type=template&id=43bf00b5&scoped=true"
import script from "./VariantsMeta.vue?vue&type=script&lang=js"
export * from "./VariantsMeta.vue?vue&type=script&lang=js"

import "./VariantsMeta.vue?vue&type=style&index=0&id=43bf00b5&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bf00b5"]])

export default __exports__